import { render, staticRenderFns } from "./LearningRequestEditV2.vue?vue&type=template&id=fb957004&"
import script from "./LearningRequestEditV2.vue?vue&type=script&lang=ts&"
export * from "./LearningRequestEditV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports